<div class="p-fluid w-[450px]">
  <div class="mb-2 text-color-secondary">
    {{ 'provider.tender.project.conclusion.confirmation.text' | transloco }}
  </div>
  <br />

  <form [formGroup]="form" (ngSubmit)="onSave()" class="flex flex-col gap-4">
    <app-form-field
      id="comment"
      label="common.comment"
      fieldName="comment"
      type="textarea"
    ></app-form-field>

    <div class="flex justify-end gap-2">
      <p-button
        [label]="'common.cancel' | transloco"
        severity="secondary"
        (onClick)="onHideDialog()"
      ></p-button>
      <p-button
        type="submit"
        [label]="'provider.tender.confirmation.declineButton' | transloco"
        [disabled]="!form.valid"
      ></p-button>
    </div>
  </form>
</div>
